import { useState } from "react";
import { Impuesto, ImpuestoResponse } from "../models/Impuesto.model";
import { TipoInscripcionDTO } from "../models/factura.model";
import { ParametroDTO } from "../models/parametros.model";
import { ProductoComercio } from "../models/ProductoComercio.model";
import { PresentacionesComercio } from "../models/PresentacionesComercio.model";
import { Transaccion } from "../models/Transaccion.model";

const useInitialState = () => {
  const [productosComercio, setProductosComercio] = useState([]);
  const [presentacionEditable, setPresentacionEditable] = useState(false)
  const[showMask,setShowMask] = useState<boolean>(false)
  const[presentacionComercio,setPresentacionComercio] = useState<PresentacionesComercio>()
  const [loadFacturaComercio, setLoadFacturaComercio] = useState<boolean>(true);
  const [presentacion, setPresentacion] = useState<number>(0);

  const [transaccionesDisponibles, setTransaccionesDisponibles] = useState([]);
  const [transaccionesSeleccionadas, setTransaccionesSeleccionadas] = useState([]);
  const [sumTDisponibles, setSumTDisponibles] = useState(0.0);
  const [sumTSeleccionadas, setSumTSeleccionadas] = useState(0.0);
  const [detailsTxDisponibles, setDetailsTxDisponibles] = useState([]);
  const [detailsTxSeleccionadas, setDetailsTxSeleccionadas] = useState([]);
  const [impuestoTasaSeleccionado, setImpuestoTasaSeleccionado] = useState<Impuesto>();
  const [flagReloadImpuestosYTasas, setFlagReloadImpuestosYTasas] = useState<number>(-1);
  const [onHideDialog, setOnHideDialog] = useState(0);
  const [selectedTxSeleccionadas, setSelectedTxSeleccionadas] = useState([]);
  const [showToastImpuestoTasaVerificado, setShowToastImpuestoTasaVerificado] = useState(-1);

  const [showDeclaracionDeImpuestosTasas, setShowDeclaracionDeImpuestosTasas] = useState(-1);
  const [flagUpdateTableImpuestosTasas, setFlagUpdateTableImpuestosTasas] = useState<number>(-1);
  const [dataImpuestos, setDataImpuestos] = useState({});
  const [spinnerImpuestosTasas, setSpinnerImpuestosTasas] = useState(true);
  const [flagCrearImpuesto, setFlagCrearImpuesto] = useState<number>(-1);
  const [flagUpdateTxDisponibles, setFlagUpdateTxDisponibles] = useState<number>(-1);

  const [totalFacturado, setTotalFacturado] = useState<number>(0);
  const [comprobantes, setComprobantes] = useState<any[]>([]);

  const [comprobanteSeleccionado, setComprobanteSeleccionado] = useState({});
  const [file, setFile] = useState();
  const [maxSize, setMaxSize] = useState(0);
  const [situacionIvaComercio, setSituacionIvaComercio] = useState<
    TipoInscripcionDTO[]
  >([]);
  const [tasasIVA, setTasasIVA] = useState();
  const [tasaIvaSelected, setTasaIvaSelected] = useState();
  const [tiposFactura, setTiposFactura] = useState();
  const [updateComprobantes, setUpdateComprobantes] = useState(-1);
  const [message, setMessage] = useState({
    life: 0,
    severity: "",
    summary: "",
    detail: "",
  });
  const [parametrosPresentacion, setParametrosPresentacion] = useState<
    ParametroDTO[]
  >([]);
  
    useState(0);
  const [spinnerComprobantes, setSpinnerComprobantes] = useState(false);
  const [fileName,setFileName] = useState("")
  const [imageComprobante,setImageComprobante] = useState({})
  const [showDialogPresentar,setShowDialogPresentar] = useState(false)
  const [ingresoManual, setIngresoManual] = useState(false);
  const [mostrarFormComprobante, setmostrarFormComprobante] = useState(false);
  const [editarOCR, seteditarOCR] = useState(false);
  const [presentacionOCR,setpresentacionOCR] = useState(false)
  
  const [presentacionState, setPresentacionState] = useState("")
  const [selectedProductoComercio, setSelectedProductoComercio] = useState<ProductoComercio | undefined>();
  const [impuestosDefault,setImpuestosDefault] = useState<ImpuestoResponse[]>([])
  const [totalImpuestosMF,setTotalImpuestosMF] = useState(0)
  const [presupuestosList,setPresupuestosList] = useState('')
  const [descargarPdf, setDescargarPdf] = useState(false);
  const [showDetailTransaction, setShowDetailTransaction] = useState<boolean>(false);
  const [lotesPendientes,setLotesPendientes] = useState<Transaccion[]>([]);
  const [detailsTxMF,setDetailsTxMF] = useState([])
  const [sumImpuestosMF, setSumImpuestosMF] = useState<number>(0.0)
  return {
    loadFacturaComercio,
    setLoadFacturaComercio,
    transaccionesDisponibles,
    setTransaccionesDisponibles,
    transaccionesSeleccionadas,
    setTransaccionesSeleccionadas,
    sumTDisponibles,
    setSumTDisponibles,
    sumTSeleccionadas,
    setSumTSeleccionadas,
    detailsTxDisponibles,
    setDetailsTxDisponibles,
    detailsTxSeleccionadas,
    setDetailsTxSeleccionadas,
    comprobantes,
    setComprobantes,
    totalFacturado,
    setTotalFacturado,
    presentacion,
    setPresentacion,
    impuestoTasaSeleccionado,
    setImpuestoTasaSeleccionado,

    flagReloadImpuestosYTasas,
    setFlagReloadImpuestosYTasas,
    onHideDialog,
    setOnHideDialog,
    flagUpdateTableImpuestosTasas,
    setFlagUpdateTableImpuestosTasas,
    selectedTxSeleccionadas,
    setSelectedTxSeleccionadas,
    flagCrearImpuesto,
    setFlagCrearImpuesto,
    dataImpuestos,
    setDataImpuestos,

    showDeclaracionDeImpuestosTasas,
    setShowDeclaracionDeImpuestosTasas,
    spinnerImpuestosTasas,
    setSpinnerImpuestosTasas,
    showToastImpuestoTasaVerificado,
    setShowToastImpuestoTasaVerificado,
    flagUpdateTxDisponibles,
    setFlagUpdateTxDisponibles,

    comprobanteSeleccionado,
    setComprobanteSeleccionado,
    file,
    setFile,
    situacionIvaComercio,
    setSituacionIvaComercio,
    tasasIVA,
    setTasasIVA,
    tasaIvaSelected,
    setTasaIvaSelected,
    tiposFactura,
    setTiposFactura,
    updateComprobantes,
    setUpdateComprobantes,
    message,
    setMessage,
    parametrosPresentacion,
    setParametrosPresentacion,
    spinnerComprobantes,
    setSpinnerComprobantes,
    fileName,setFileName,
    imageComprobante,setImageComprobante,
    showDialogPresentar,setShowDialogPresentar,
    presentacionEditable,setPresentacionEditable,
    presentacionState, setPresentacionState,
    showMask,setShowMask,
    presentacionComercio,setPresentacionComercio,
    productosComercio, setProductosComercio,
    selectedProductoComercio, setSelectedProductoComercio,
    impuestosDefault,setImpuestosDefault,
    totalImpuestosMF,setTotalImpuestosMF,
    presupuestosList,setPresupuestosList,
    maxSize,setMaxSize,
    descargarPdf, setDescargarPdf,
    showDetailTransaction, setShowDetailTransaction,
    lotesPendientes,setLotesPendientes,
    detailsTxMF,setDetailsTxMF,
    sumImpuestosMF, setSumImpuestosMF,
    ingresoManual, setIngresoManual,
    mostrarFormComprobante, setmostrarFormComprobante,
    editarOCR, seteditarOCR,
    presentacionOCR,setpresentacionOCR
  };
};

export default useInitialState;
